import PropTypes from 'prop-types';
import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import {
  addCalendarAsset, fetchCalendarAssets, fetchWebAssetTemplates, refreshCalendarAsset,
  setPageTitle, updateCalendarAsset,
} from '../../actions';
import { Page } from '../../components';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';
import { getAsset, getCalendarAssetTemplates } from '../../selectors';
import './styles.scss';

class CalendarAssetEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {...props.asset};
  }

  static propTypes = {
    fetchCalendarAssets: PropTypes.func.isRequired,
    refreshCalendarAsset: PropTypes.func.isRequired,
    fetchWebAssetTemplates: PropTypes.func.isRequired,
    updateCalendarAsset: PropTypes.func.isRequired,
    addCalendarAsset: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    asset: PropTypes.object,
    params: PropTypes.object,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    templates: PropTypes.array.isRequired,
  };

  handleCancel = () => this.props.history.push('/assets');

  handleNameChange = (e) => this.setState({name: e.currentTarget.value});

  handleRefresh = () => this.props.refreshCalendarAsset(this.props.asset);

  handleSave = () => {
    if (this.props.asset) {
      this.props.updateCalendarAsset(this.props.asset.id, this.state);
      this.props.history.push(`/asset/${this.props.asset.id}`);
    } else if (this.isNewAsset()) {
      this.props.addCalendarAsset(this.state);
      this.props.history.push('/assets');
    }
  }

  handleTemplateChange = (e) => this.setState({template: e.currentTarget.value});

  handleUrlChange = (e) => this.setState({url: e.currentTarget.value});

  isNewAsset = () => this.props.match.params.id === undefined;

  componentDidMount() {
    this.props.fetchCalendarAssets();
    this.props.fetchWebAssetTemplates();
    if (this.props.asset) {
      this.props.setPageTitle(`${this.props.asset.id ? 'Editing' : 'Adding'} Calendar Asset`);
    } else {
      this.props.setPageTitle('Adding Calendar Asset');
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.asset !== newProps.asset) {
      this.setState(newProps.asset);
    }
  }

  render() {
    if (this.props.asset === undefined && this.props.match.params.id) {
      return <div>Invalid asset.</div>;
    }

    const {name, template, url} = this.state;
    const templateData = this.props.templates.find(t => t.id == template);

    return (
      <Page className="cal-asset-editing-page">
        <input type="text" placeholder="Asset name"
               value={name || ''}
               onChange={this.handleNameChange}/>
        <Box direction="row">
          <input type="url" placeholder="Calendar URL"
                 value={url}
                 onChange={this.handleUrlChange}/>
          {this.isNewAsset() ||
          <Button onClick={this.handleRefresh}>Refresh</Button>}
        </Box>
        <select id="template-selector" name="template-selector"
                value={template}
                onChange={this.handleTemplateChange}>
          <option value="NULL" key="null">----</option>
          {this.props.templates.map(template =>
            (<option key={template.id}
                     value={template.id}>{template.name}</option>),
          )}
        </select>
        {templateData &&
        <div className="help"
             dangerouslySetInnerHTML={{__html: templateData.help_html}}/>}
        {templateData && <iframe srcDoc={templateData.template}/>}
        <Box direction="row" justifyContent="flex-end" className="actions button-group">
          <Button primary onClick={this.saveEnabled() ? this.handleSave : null}>Save</Button>
          <Button secondary onClick={this.handleCancel}>Cancel</Button>
        </Box>
      </Page>
    );
  }

  saveEnabled() {
    return this.state && this.state.name && this.state.url;
  }
}

export default connect(
  (state, {match}) => ({
    asset: getAsset(state, parseInt(match.params.id, 10)),
    templates: getCalendarAssetTemplates(state),
  }), {
    fetchCalendarAssets,
    fetchWebAssetTemplates,
    refreshCalendarAsset,
    updateCalendarAsset,
    addCalendarAsset,
    setPageTitle,
  },
)(CalendarAssetEditPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/CalendarAssetEditPage/index.js